export default __webpack_public_path__ + "static/media/portadavideoanalisis1.631bc2e5.png";